import { getCookieValue } from "./cookies/getCookieValue.esm.js";
const PERSISTED_UTM_FIELDS = ["utm_medium", "utm_term", "utm_content", "utm_source", "utm_campaign"];
const CLICKSTREAM_UTM_COOKIES = {
  utm_medium: "zjs_utmmedium",
  utm_term: "zjs_utmterm",
  utm_content: "zjs_utmcontent",
  utm_source: "zjs_utmsource",
  utm_campaign: "zjs_utmcampaign"
};
function parseClickstreamValue(raw) {
  if (raw === null || raw === "" || raw === "null") {
    return null;
  }
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === "string" && parsed !== "" ? parsed : null;
  } catch {
    return raw;
  }
}
function readClickstreamUtms() {
  const out = {};
  for (const field of PERSISTED_UTM_FIELDS) {
    const value = parseClickstreamValue(getCookieValue(CLICKSTREAM_UTM_COOKIES[field]));
    if (value) {
      out[field] = value;
    }
  }
  return out;
}
function getTrackingParamsFromCurrentUrl() {
  var _a;
  const params = new URLSearchParams(window.location.search);
  const currentTrackingValues = {
    utm_medium: params.get("utm_medium"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
    utm_source: params.get("utm_source"),
    utm_campaign: params.get("utm_campaign"),
    Internal_Tracking_Code: params.get("itc"),
    URL: window.location.origin + window.location.pathname,
    URL_Referrer: ((_a = document.referrer) == null ? void 0 : _a.split("?")[0]) || ""
  };
  if (params.has("gclid")) {
    Object.assign(currentTrackingValues, {
      utm_medium: "cpc",
      utm_source: "google",
      utm_campaign: "zbw_",
      utm_term: `${params.get("semAdid")}|${params.get("semKwid")}|${params.get("semAdgid")}`
    });
    return currentTrackingValues;
  }
  const clickstream = readClickstreamUtms();
  for (const field of PERSISTED_UTM_FIELDS) {
    if (!currentTrackingValues[field]) {
      currentTrackingValues[field] = clickstream[field] ?? currentTrackingValues[field];
    }
  }
  return currentTrackingValues;
}
export {
  getTrackingParamsFromCurrentUrl
};
